import { i18n } from '@/locales';
/**
 * 상점의 본사계약여부
 * https://www.notion.so/barogohq/AC-S008-_P1-db2a3df923f0445faa776f75234e50f5?pvs=4#16fe4595a82e48d484bddc006dee5dda
 */
const lc = 'views.store_management.adjustment_type.';
const adjustmentTypeCode = {
    /** 본사 계약 상점 */
    HEADOFFICE: {
        value: 'HEADOFFICE',
        text: i18n.t(`${lc}headoffice`),
    },
    // https://barogo.slack.com/archives/C04UP4VFCKA/p1697524989624849
    /** 허브 계약 (사용 안 함) <- 텍스트 변경 기각. */
    HUB: {
        value: 'HUB',
        text: i18n.t(`${lc}hub`),
    },
    /** ?? */
    ORDER_HUB: {
        value: 'ORDER_HUB',
        text: i18n.t(`${lc}order_hub`),
    },
};
const adjustmentTypeCodeDisabledData = {
    // 수정 + 본사계약 상점은 사용 안함 내지는 부가세발주(o)가 불가하다. 본사계약으로만 고정
    headoffice: {
        // 비활성
        [adjustmentTypeCode.HEADOFFICE.value]: false,
        // 활성
        [adjustmentTypeCode.HUB.value]: true,
        // 활성
        [adjustmentTypeCode.ORDER_HUB.value]: true,
    },
    // 수정시에는 본사계약을 선택할 수 없다.
    edit: {
        // 활성
        [adjustmentTypeCode.HEADOFFICE.value]: true,
        // 비활성
        [adjustmentTypeCode.HUB.value]: false,
        // 활성
        [adjustmentTypeCode.ORDER_HUB.value]: false,
    },
    // 상점 생성시 (현재 상점 생성이 안되므로 사용되지 않음)
    create: {
        // 비활성
        [adjustmentTypeCode.HEADOFFICE.value]: true,
        // 활성
        [adjustmentTypeCode.HUB.value]: true,
        // 활성
        [adjustmentTypeCode.ORDER_HUB.value]: true,
    },
};
/**
 * 상황에 맞는 본사계약 코드 조회
 * @param type edit | create | headoffice (본사에서 관리함)
 * @returns
 */
export const getAdjustmentTypeCode = (type = 'edit') => Object
    .values(adjustmentTypeCode)
    .map((item) => ({
    ...item,
    disabled: adjustmentTypeCodeDisabledData[type][item.value],
}));
export default adjustmentTypeCode;
